"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagedTable = void 0;
var react_1 = __importDefault(require("react"));
var DataTable_1 = require("../DataTable/DataTable");
var TableFooter_1 = require("../TableFooter/TableFooter");
var TableContainer_1 = require("./TableContainer");
function PagedTable(props) {
    var onPageChange = props.onPageChange, onSizeChange = props.onSizeChange, page = props.page, size = props.size, totalPages = props.totalPages, totalElements = props.totalElements, sizeOptions = props.sizeOptions, rest = __rest(props, ["onPageChange", "onSizeChange", "page", "size", "totalPages", "totalElements", "sizeOptions"]);
    return (react_1.default.createElement(TableContainer_1.TableContainer, null,
        react_1.default.createElement(DataTable_1.DataTable, __assign({}, rest)),
        react_1.default.createElement(TableFooter_1.TableFooter, { style: { borderTop: 'none' }, page: page, pageSize: size, totalPages: totalPages, totalElements: totalElements, sizeOptions: sizeOptions, onPageChange: onPageChange, onSizeChange: onSizeChange })));
}
exports.PagedTable = PagedTable;
//# sourceMappingURL=PagedTable.js.map